import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useFormContext } from "react-hook-form";

import { FormControl } from "../Form";
import FormInput from "../FormInput";
import Icon from "../../Icon";
import Button from "../../Button";

import usePreviousSearchesStore from "../../../store/PreviousSearches.store";

import "./searchInput.scss";

const SearchInput = ({
  name,
  label,
  options,
  autoComplete = "off",
  className,
  setSearchKeyword,
}) => {
  const searchContainerRef = useRef(null);
  const { register } = useFormContext();
  const [searchValue, setSearchValue] = useState("");
  const [hasValue, setHasValue] = useState(false);

  const addSearchKeyword = usePreviousSearchesStore(
    (state) => state.actions.addSearchKeyword
  );
  const getPreviousSearches = usePreviousSearchesStore(
    (state) => state.actions.getPreviousSearches
  );
  const previousSearchKeywords = getPreviousSearches();

  const removeFocus = () => {
    document.activeElement.blur();
  };

  const handleClick = (e) => {
    const value = e.currentTarget.dataset.value || "";
    setSearchValue(value);
    setSearchKeyword(value);

    removeFocus();

    //Previous Search
    if (searchValue.length > 0) {
      addSearchKeyword(searchValue);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e?.target?.querySelector("input")?.blur();
    setSearchKeyword(searchValue);

    removeFocus();

    //Previous Search
    if (searchValue.length > 0) {
      addSearchKeyword(searchValue);
    }
  };

  useEffect(() => {
    setHasValue(searchValue.length > 0);
  }, [searchValue]);

  return (
    <div ref={searchContainerRef} className="search-container">
      <FormControl>
        <FormInput
          type="text"
          className={classnames("form-input--search", className)}
        >
          <Icon name="system-search" />
          <form onSubmit={handleSubmit}>
            <input
              id={name}
              type="text"
              className="search-input"
              placeholder={label}
              autoComplete={autoComplete}
              {...register(name, {
                ...options,
              })}
              onChange={(e) => {
                const value = e.currentTarget.value;
                setSearchValue(value);
              }}
              value={searchValue}
            />
          </form>

          <button
            className={classnames("search-clear-btn", {
              "search-clear-btn--visible": hasValue,
            })}
            onClick={() => {
              setSearchValue("");
              setSearchKeyword("");
            }}
            title="Clear search"
          >
            <Icon name="system-close" />
          </button>

          <div className="previous-search">
            {previousSearchKeywords?.length > 0 ? (
              <>
                <p>Previous searches</p>
                <ul>
                  {previousSearchKeywords.map((item, i) => (
                    <li key={i}>
                      <button onClick={handleClick} data-value={item}>
                        <Icon name="system-search" /> {item}
                      </button>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <p>No previous searches</p>
            )}
          </div>
        </FormInput>
        <Button
          size="small"
          className="toolbarHeaderCta"
          onClick={handleSubmit}
        >
          Search
        </Button>
      </FormControl>
    </div>
  );
};

SearchInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.object,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  setSearchKeyword: PropTypes.func,
};

SearchInput.defaultProps = {
  options: {},
  autoComplete: "off",
  setSearchKeyword: () => {},
};

export default SearchInput;
